var map = {
	"./1": 137,
	"./1.png": 137,
	"./2": 138,
	"./2.png": 138,
	"./3": 139,
	"./3.png": 139,
	"./4": 140,
	"./4.png": 140,
	"./about": 141,
	"./about.png": 141,
	"./activity": 236,
	"./activity.svg": 236,
	"./add-cta": 311,
	"./add-cta-active": 312,
	"./add-cta-active.svg": 312,
	"./add-cta.svg": 311,
	"./added-to-collections-active": 313,
	"./added-to-collections-active.svg": 313,
	"./adobe": 142,
	"./adobe.png": 142,
	"./analytics": 314,
	"./analytics.svg": 314,
	"./annotate": 315,
	"./annotate-active": 316,
	"./annotate-active.svg": 316,
	"./annotate.svg": 315,
	"./annotate/arrow": 275,
	"./annotate/arrow.svg": 275,
	"./annotate/crop": 276,
	"./annotate/crop.svg": 276,
	"./annotate/draw": 277,
	"./annotate/draw.svg": 277,
	"./annotate/ellipse": 278,
	"./annotate/ellipse-focus": 279,
	"./annotate/ellipse-focus.svg": 279,
	"./annotate/ellipse.svg": 278,
	"./annotate/emoji": 122,
	"./annotate/emoji.png": 122,
	"./annotate/emoji@2x": 123,
	"./annotate/emoji@2x.png": 123,
	"./annotate/emoji@3x": 124,
	"./annotate/emoji@3x.png": 124,
	"./annotate/highlighter": 280,
	"./annotate/highlighter.svg": 280,
	"./annotate/line": 281,
	"./annotate/line.svg": 281,
	"./annotate/number": 282,
	"./annotate/number.svg": 282,
	"./annotate/pixelate": 283,
	"./annotate/pixelate.svg": 283,
	"./annotate/rect": 284,
	"./annotate/rect.svg": 284,
	"./annotate/square-focus": 285,
	"./annotate/square-focus.svg": 285,
	"./annotate/text": 286,
	"./annotate/text.svg": 286,
	"./annotate/tools-history-back": 287,
	"./annotate/tools-history-back-disabled": 288,
	"./annotate/tools-history-back-disabled.svg": 288,
	"./annotate/tools-history-back.svg": 287,
	"./annotate/tools-history-forward": 289,
	"./annotate/tools-history-forward-disabled": 290,
	"./annotate/tools-history-forward-disabled.svg": 290,
	"./annotate/tools-history-forward.svg": 289,
	"./annotate/tools-zoom-zoom-in": 271,
	"./annotate/tools-zoom-zoom-in.svg": 271,
	"./annotate/tools-zoom-zoom-out": 272,
	"./annotate/tools-zoom-zoom-out.svg": 272,
	"./app-icon": 317,
	"./app-icon.svg": 317,
	"./apple": 318,
	"./apple.svg": 318,
	"./apple_logo": 223,
	"./apple_logo.svg": 223,
	"./arrow-big": 143,
	"./arrow-big.png": 143,
	"./atlassian": 144,
	"./atlassian.png": 144,
	"./bg-bottom": 145,
	"./bg-bottom.png": 145,
	"./bg-top": 146,
	"./bg-top.png": 146,
	"./bill": 319,
	"./bill.svg": 319,
	"./blurred-drop": 97,
	"./blurred-drop.png": 97,
	"./branding": 273,
	"./branding.svg": 273,
	"./buttons-add-new-collection-hover": 320,
	"./buttons-add-new-collection-hover.svg": 320,
	"./buttons-add-new-collection-sidebar": 321,
	"./buttons-add-new-collection-sidebar.svg": 321,
	"./card-generic": 112,
	"./card-generic.png": 112,
	"./check-mark": 322,
	"./check-mark.svg": 322,
	"./checkmark": 323,
	"./checkmark.svg": 323,
	"./checkmark@2x": 147,
	"./checkmark@2x.png": 147,
	"./chrome": 324,
	"./chrome.svg": 324,
	"./close": 293,
	"./close.svg": 293,
	"./cloud-loader": 255,
	"./cloud-loader.gif": 255,
	"./cloudapp": 148,
	"./cloudapp-favicon": 149,
	"./cloudapp-favicon.png": 149,
	"./cloudapp-icon": 150,
	"./cloudapp-icon.png": 150,
	"./cloudapp-logo-horizontal": 214,
	"./cloudapp-logo-horizontal.svg": 214,
	"./cloudapp.png": 148,
	"./coach-mark": 325,
	"./coach-mark.svg": 325,
	"./collection": 215,
	"./collection.svg": 215,
	"./conversation": 326,
	"./conversation.svg": 326,
	"./dashboard": 237,
	"./dashboard.svg": 237,
	"./download-arrow": 327,
	"./download-arrow.svg": 327,
	"./download-chrome": 328,
	"./download-chrome.svg": 328,
	"./download-cloud": 329,
	"./download-cloud.svg": 329,
	"./download-drop": 330,
	"./download-drop.svg": 330,
	"./download-mac": 331,
	"./download-mac.svg": 331,
	"./download-windows": 332,
	"./download-windows.svg": 332,
	"./download_icon_chrome": 333,
	"./download_icon_chrome.svg": 333,
	"./download_icon_mac": 334,
	"./download_icon_mac.svg": 334,
	"./download_icon_windows": 335,
	"./download_icon_windows.svg": 335,
	"./email": 224,
	"./email.svg": 224,
	"./enterprise@2x": 151,
	"./enterprise@2x.png": 151,
	"./file-placeholder": 291,
	"./file-placeholder.svg": 291,
	"./free@2x": 152,
	"./free@2x.png": 152,
	"./free_plan_icon": 153,
	"./free_plan_icon.png": 153,
	"./gift": 256,
	"./gift.svg": 256,
	"./google_logo": 225,
	"./google_logo.svg": 225,
	"./hat-icon": 336,
	"./hat-icon.svg": 336,
	"./hero-asset": 98,
	"./hero-asset.gif": 506,
	"./hero-asset.png": 98,
	"./icon-clock": 226,
	"./icon-clock.jpeg": 226,
	"./icon-get-cloudapp": 194,
	"./icon-get-cloudapp.svg": 194,
	"./icon-google": 337,
	"./icon-google.svg": 337,
	"./icon-muted": 292,
	"./icon-muted.svg": 292,
	"./icon-muted@2x": 154,
	"./icon-muted@2x.png": 154,
	"./icons-add": 257,
	"./icons-add-bordered": 155,
	"./icons-add-bordered.png": 155,
	"./icons-add-to-collection-solid": 338,
	"./icons-add-to-collection-solid.svg": 338,
	"./icons-add.svg": 257,
	"./icons-announcement": 339,
	"./icons-announcement.svg": 339,
	"./icons-bug": 340,
	"./icons-bug.svg": 340,
	"./icons-card-actions-compact-read-only": 113,
	"./icons-card-actions-compact-read-only.svg": 113,
	"./icons-clipboard": 244,
	"./icons-clipboard.svg": 244,
	"./icons-close": 270,
	"./icons-close.svg": 270,
	"./icons-conversation": 119,
	"./icons-conversation.svg": 119,
	"./icons-download-bordered": 156,
	"./icons-download-bordered.png": 156,
	"./icons-download-solid": 341,
	"./icons-download-solid.svg": 341,
	"./icons-edit-minimal": 227,
	"./icons-edit-minimal.svg": 227,
	"./icons-embed-bordered": 157,
	"./icons-embed-bordered.png": 157,
	"./icons-embed-solid": 342,
	"./icons-embed-solid.svg": 342,
	"./icons-hidden": 343,
	"./icons-hidden.svg": 343,
	"./icons-invite-active": 238,
	"./icons-invite-active.svg": 238,
	"./icons-invite-default": 239,
	"./icons-invite-default.svg": 239,
	"./icons-locked-bordered": 158,
	"./icons-locked-bordered.png": 158,
	"./icons-magic": 344,
	"./icons-magic.svg": 344,
	"./icons-mouse-click": 345,
	"./icons-mouse-click-gray": 346,
	"./icons-mouse-click-gray.svg": 346,
	"./icons-mouse-click.svg": 345,
	"./icons-new": 159,
	"./icons-new-gray": 258,
	"./icons-new-gray.svg": 258,
	"./icons-new-transparent": 259,
	"./icons-new-transparent.svg": 259,
	"./icons-new-white": 260,
	"./icons-new-white.svg": 260,
	"./icons-new.svg": 159,
	"./icons-notifications": 120,
	"./icons-notifications-active": 121,
	"./icons-notifications-active.svg": 121,
	"./icons-notifications.svg": 120,
	"./icons-rainbow-circle": 160,
	"./icons-rainbow-circle.png": 160,
	"./icons-rounded-corners": 347,
	"./icons-rounded-corners.svg": 347,
	"./icons-sales": 348,
	"./icons-sales.svg": 348,
	"./icons-search": 349,
	"./icons-search.svg": 349,
	"./icons-settings-blue": 261,
	"./icons-settings-blue.svg": 261,
	"./icons-settings-gray": 228,
	"./icons-settings-gray.svg": 228,
	"./icons-share-settings-locked": 350,
	"./icons-share-settings-locked.svg": 350,
	"./icons-slightly-rounded-corners": 351,
	"./icons-slightly-rounded-corners.svg": 351,
	"./icons-square-corners": 352,
	"./icons-square-corners.svg": 352,
	"./icons-support": 353,
	"./icons-support.svg": 353,
	"./icons-toggle-close": 262,
	"./icons-toggle-close.svg": 262,
	"./icons-toggle-open": 263,
	"./icons-toggle-open.svg": 263,
	"./icons-transcribe": 229,
	"./icons-transcribe.svg": 229,
	"./illustrations-transcription-processing": 264,
	"./illustrations-transcription-processing.svg": 264,
	"./indicator-right": 354,
	"./indicator-right.svg": 354,
	"./infinite": 274,
	"./infinite.svg": 274,
	"./installer": 355,
	"./installer.svg": 355,
	"./logo-visa": 356,
	"./logo-visa.jpeg": 356,
	"./logo@2x": 90,
	"./logo@2x-blue": 161,
	"./logo@2x-blue.png": 161,
	"./logo@2x.png": 90,
	"./logos-cloud-app-logomark-full-color": 230,
	"./logos-cloud-app-logomark-full-color.svg": 230,
	"./main-banner": 162,
	"./main-banner.png": 162,
	"./menu-bar": 357,
	"./menu-bar.svg": 357,
	"./onboarding/apple": 195,
	"./onboarding/apple.svg": 195,
	"./onboarding/bill": 163,
	"./onboarding/bill.svg": 163,
	"./onboarding/chrome": 196,
	"./onboarding/chrome.svg": 196,
	"./onboarding/download-arrow": 197,
	"./onboarding/download-arrow.svg": 197,
	"./onboarding/download-chrome": 198,
	"./onboarding/download-chrome.svg": 198,
	"./onboarding/download-drop": 199,
	"./onboarding/download-drop.svg": 199,
	"./onboarding/download-mac": 200,
	"./onboarding/download-mac.svg": 200,
	"./onboarding/download-windows": 201,
	"./onboarding/download-windows.svg": 201,
	"./onboarding/email": 164,
	"./onboarding/email.svg": 164,
	"./onboarding/hat-icon": 202,
	"./onboarding/hat-icon.svg": 202,
	"./onboarding/icons-check": 114,
	"./onboarding/icons-check.svg": 114,
	"./onboarding/icons-chrome-desaturated": 203,
	"./onboarding/icons-chrome-desaturated.svg": 203,
	"./onboarding/icons-cloud-app-app": 204,
	"./onboarding/icons-cloud-app-app.svg": 204,
	"./onboarding/icons-download": 165,
	"./onboarding/icons-download.svg": 165,
	"./onboarding/icons-extension": 166,
	"./onboarding/icons-extension.svg": 166,
	"./onboarding/installer": 205,
	"./onboarding/installer.svg": 205,
	"./onboarding/menu-bar": 206,
	"./onboarding/menu-bar.svg": 206,
	"./onboarding/start": 167,
	"./onboarding/start.svg": 167,
	"./onboarding/windows": 207,
	"./onboarding/windows.svg": 207,
	"./parallax": 358,
	"./parallax.jpg": 358,
	"./pattern": 168,
	"./pattern-2": 169,
	"./pattern-2.png": 169,
	"./pattern-4": 170,
	"./pattern-4.png": 170,
	"./pattern.png": 168,
	"./plus": 359,
	"./plus-small": 360,
	"./plus-small.svg": 360,
	"./plus.svg": 359,
	"./prize": 361,
	"./prize.svg": 361,
	"./prize@2x": 102,
	"./prize@2x.png": 102,
	"./pro-badge": 208,
	"./pro-badge.svg": 208,
	"./pro-ribbon": 89,
	"./pro-ribbon.png": 89,
	"./pro-ribbon.svg": 507,
	"./pro@1x": 171,
	"./pro@1x.png": 171,
	"./pro@2x": 115,
	"./pro@2x.png": 115,
	"./pro@3x": 172,
	"./pro@3x.png": 172,
	"./pro_plan_icon": 173,
	"./pro_plan_icon.png": 173,
	"./salesforce": 174,
	"./salesforce.png": 174,
	"./seats-left": 362,
	"./seats-left.svg": 362,
	"./spinner": 64,
	"./spinner.svg": 64,
	"./start": 363,
	"./start.svg": 363,
	"./team": 231,
	"./team-3": 364,
	"./team-3.jpg": 364,
	"./team.svg": 231,
	"./team@2x": 116,
	"./team@2x.png": 116,
	"./team_plan_icon": 125,
	"./team_plan_icon.png": 125,
	"./team_sidebar": 175,
	"./team_sidebar.png": 175,
	"./thumbnail": 176,
	"./thumbnail.png": 176,
	"./upload-arrow": 365,
	"./upload-arrow.svg": 365,
	"./upload-cloud": 366,
	"./upload-cloud.svg": 366,
	"./upload-copy": 177,
	"./upload-copy.png": 177,
	"./upload-copy@2x": 178,
	"./upload-copy@2x.png": 178,
	"./upload-copy@3x": 179,
	"./upload-copy@3x.png": 179,
	"./upload-drop": 367,
	"./upload-drop.svg": 367,
	"./video-thumbnail": 180,
	"./video-thumbnail.png": 180,
	"./video-trim": 368,
	"./video-trim-active": 369,
	"./video-trim-active.svg": 369,
	"./video-trim.svg": 368,
	"./view-grid": 370,
	"./view-grid-active": 371,
	"./view-grid-active.svg": 371,
	"./view-grid.svg": 370,
	"./view-list": 372,
	"./view-list-active": 373,
	"./view-list-active.svg": 373,
	"./view-list.svg": 372,
	"./windows": 374,
	"./windows.svg": 374,
	"./your_plan_badge@2x": 181,
	"./your_plan_badge@2x.png": 181,
	"./zendesk": 182,
	"./zendesk.png": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;